<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport="true" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async)">

    <mat-toolbar class="border-bottom">
      <img class="img-responsive center-block akibaLogo" src="{{akibaLogoUrl}}" />
    </mat-toolbar>

    <mat-nav-list>

      <span *ngFor="let sideBarItem of sideBarItems">

        <a mat-list-item *ngIf="logicService.dataManager.proxyDataLoader.employee && sideBarItem.visible === false; else normal" [routerLink]="[sideBarItem.path]" routerLinkActive="active" #rla="routerLinkActive">
          <mat-icon matListIcon>{{sideBarItem.icon}}</mat-icon>
          <span [innerHTML]="sideBarItem.title"></span>
          <span [matBadge]="pendingLoanCount" matBadgeColor="warn" [matBadgeHidden]="!shouldShowBadge(sideBarItem.path)"></span>
        </a>

        <ng-template #normal>

          <a mat-list-item *ngIf="!logicService.dataManager.proxyDataLoader.employee  && !sideBarItem.divider && sideBarItem.visible === true; else showDivider" [routerLink]="[sideBarItem.path]" routerLinkActive="active" #rla="routerLinkActive">
            <mat-icon matListIcon>{{sideBarItem.icon}}</mat-icon>
            <span [innerHTML]="sideBarItem.title"></span>
            <span [matBadge]="pendingLoanCount" matBadgeColor="warn" [matBadgeHidden]="!shouldShowBadge(sideBarItem.path)"></span>
          </a>

          <ng-template #showDivider>
            <mat-divider style="margin: 0% 20%" *ngIf="!logicService.dataManager.proxyDataLoader.employee && sideBarItem.divider"></mat-divider>
          </ng-template>

        </ng-template>

      </span>

    </mat-nav-list>

  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <div class="bb-header">
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()" *ngIf="isHandset$ | async">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
  
        <img class="img-responsive center-block header-logo" src="{{logoCompany}}" />
  
        <button mat-icon-button color="primary" class="mat-icon-button mat-primary" [matMenuTriggerFor]="appMenu">
          <mat-icon>person</mat-icon>
        </button>

      </div>

      <mat-menu #appMenu="matMenu">

        <div *ngFor="let menuItem of menuItems" [routerLink]="[menuItem.path]" [routerLinkActiveOptions]="{ exact: false }" routerLinkActive="activeMenu" #rla="routerLinkActive">
          <button mat-menu-item>{{rla.isActive ? '' : 'Ver como '}} {{menuItem.title}}</button>
        </div>

        <hr style="margin: 0px; padding: 0px;">
        <button mat-menu-item (click)="logOut()">Salir</button>
      </mat-menu>

    </mat-toolbar>
    <div class="content">
      <div class="container-fluid page-content">
        <div class="row">
          <div class="col-md-12">
            <div class="main-panel">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
